import React from "react";

class SkipToContent extends React.Component {

    render() {
      return (
    		<div id="skip-to-content">
          <a className="skip-main" href="#main" tabIndex="1">Skip to main content</a>
        </div>
      );
   }
}

export default SkipToContent;
